import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import cookieStorage from '../middleware/persistToCookies.js';

export interface AuthState {
  token: string | null;
  role: string;
  setToken: (token: string) => void;
  setRole: (token: string) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      role: '',
      setToken: (token) => set({ token }),
      setRole: (role) => set({ role }),
      logout: () => {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf('=');
          const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        }
        set({ token: null });
      },
      isAuthenticated: () => !!get().token,
    }),
    {
      name: 'store-auth',
      storage: cookieStorage,
    },
  ),
);
